import { useEffect, useState } from "react";
import { useTranslation } from "@/shared/i18n/LocaleProvider";
import { fontSizeVar } from "@/shared/ui/type-scale";

export function ThinkingIndicator({ phrase }: { phrase: string }) {
  const { t } = useTranslation();
  const [textVisible, setTextVisible] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setTextVisible(true), TEXT_REVEAL_MS);
    return () => clearTimeout(id);
  }, []);

  return (
    <div
      role="status"
      className="flex items-center gap-[8px]"
      aria-live="polite"
      aria-label={textVisible ? undefined : t("thread.thinkingLabel")}
    >
      <ThinkingDots />
      {textVisible && (
        <p
          className="thinking-label-enter italic text-[var(--color-text-muted)]"
          style={{ fontFamily: "var(--font-display)", fontSize: fontSizeVar("md") }}
        >
          {phrase}
        </p>
      )}
    </div>
  );
}

function ThinkingDots() {
  return (
    <svg width="10" height="20" viewBox="0 0 10 20" aria-hidden="true" className="shrink-0">
      <circle
        cx="5"
        cy="6"
        r="3.5"
        fill="var(--color-brand)"
        className="[animation:thinking-pulse_1.2s_ease-in-out_infinite]"
      />
      <circle
        cx="5"
        cy="14"
        r="3.5"
        fill="var(--color-brand)"
        className="[animation:thinking-pulse_1.2s_ease-in-out_infinite] [animation-delay:600ms]"
      />
    </svg>
  );
}

const TEXT_REVEAL_MS = 2000;
